import React from "react";
import { Avatar, Space, Typography } from "antd";
import { useLicensesActions, useLicensesState } from "src/reducers/subscription";

const { Text } = Typography;
const SubscriptionDrawerHeader = () => {

    const { selected } = useLicensesState();

    return (
        <Space align="center">
            <Avatar shape="square" src={selected.img} />
            <div>
                <Text strong>{selected.service || selected.plan}</Text>
                <div style={{ fontSize: 12, opacity: 0.7 }}>{selected.plan}</div>
            </div>
        </Space>

    )
}

export default SubscriptionDrawerHeader;